import { AxiosInstance } from "axios";
import VuetifySelectItems from '@/types/app/vuetifySelectItems';
import Endpoint from '@/utils/endpoint';
import compareTo from '@/utils/compareTo';

export default class ProductService {

    constructor(
        private http: AxiosInstance,
        private endpoint: Endpoint = new Endpoint()
    ) { }

    async getProducts(): Promise<VuetifySelectItems[]> {
  
        let itemsForVuetifySelect: any[] = []
        try {
            const url = this.endpoint.productSelectItems;
            const response = await this.http.get(`${url}`);
            itemsForVuetifySelect = response.data?.items as VuetifySelectItems[];
            if (itemsForVuetifySelect) {
                itemsForVuetifySelect = itemsForVuetifySelect.sort((a, b) =>
                    compareTo(a.text, b.text)
                );
            }

        } catch (error) {
            console.log(error);
        }

        return itemsForVuetifySelect;
    }
}